import { Route, Redirect } from "react-router";
import { useKeycloak } from "@react-keycloak/web";


const PrivateRoute = ({ component: Component, location, search, ...rest }) => {
    const { keycloak } = useKeycloak();

    return <Route {...rest} render={(props) => (
        keycloak.authenticated
            ? <Component {...props} />
            : <Redirect to={'/login?from=' + encodeURIComponent(location.pathname) + encodeURIComponent(location.search)} />
        )} />
};

export { PrivateRoute };